import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KpiModule } from './kpi/kpi.module';
import { KpiGroupModule } from './kpi-group/kpi-group.module';
import { TabHeaderModule } from './tab-header/tab-header.module';
import { FileDownloadPopupComponent } from './file-download-popup/file-download-popup.component';
import { TreeTableModule } from 'primeng/treetable';
import { SharedService } from './shared.service';
import { ChartLegendComponent } from './chart-legend/chart-legend.component';
import { OuterAxisComponent } from './outer-axis/outer-axis.component';
import { ToastComponent } from './toast/toast.component';
import { ShortNumberPipe } from './pipes/short-number.pipe';
import { TnFormatPipe } from './pipes/tn-format.pipe';
import { InfoPopoverModule } from './info-popover/info-popover.module';
import { DashboardRefreshTimerModule } from './dashboard-refresh-timer/dashboard-refresh-timer.module';
import { SiTimezoneComponent } from './si-timezone/si-timezone.component';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { CommaSpacePipe } from './pipes/comma-space.pipe';
import { SiKeyCloakLoginComponent } from './si-keycloak-redirect/si-keycloak-login/si-keycloak-login.component';
import { SiKeyCloakLogoutComponent } from './si-keycloak-redirect/si-keycloak-logout/si-keycloak-logout.component';
import { SiKeyCloakSSOComponent } from './si-keycloak-redirect/si-keycloak-sso/si-keycloak-sso.component';
import { IntlTelInputDirective } from './intl-tel-input/intl-tel-input.directive';

@NgModule({
  imports: [
    CommonModule,
    KpiModule,
    KpiGroupModule,
    TabHeaderModule,
    TreeTableModule,
    DropdownModule,
    FormsModule,
    ButtonModule,
    InfoPopoverModule
  ],
  declarations: [ChartLegendComponent, OuterAxisComponent,
    FileDownloadPopupComponent, ToastComponent, ShortNumberPipe, CommaSpacePipe,
    TnFormatPipe, SiTimezoneComponent, SiKeyCloakLoginComponent, SiKeyCloakLogoutComponent, SiKeyCloakSSOComponent,
    IntlTelInputDirective
  ],
  providers: [SharedService],
  exports: [
    KpiModule,
    KpiGroupModule,
    TabHeaderModule,
    ChartLegendComponent,
    OuterAxisComponent,
    FileDownloadPopupComponent,
    ToastComponent,
    ShortNumberPipe,
    CommaSpacePipe,
    TnFormatPipe,
    DashboardRefreshTimerModule,
    SiTimezoneComponent,
    InfoPopoverModule,
    IntlTelInputDirective
  ]
})
export class SharedModule { }
